<template></template>

<script>
    export default {
        props: {
            nom: String,
            prenom: String,
            situation_familiale: String,
            adresse_mail: String,
            code_postal: String,
            situation_professionnelle: String,
            numero_de_police: String,
            contrat: String,
            agence: String,
            numero_sinistre: String,
            numero_adherent: String,
            datetimefr: String,
            statut: String,
            idclientexterne: String,
            motif_resiliation: String,
            novice: String
        },
        created() {
            window._Mfb_ud = {
                _context: {
                    lang: undefined, // You can force the language of the survey.
                    _page: {
                        url: location.pathname,
                        storageDuration: 30
                        // You can add page's properties here ie : pageProperties : { property1 : 'value', property2 : 'value'}
                    }
                }
            };

            for (const property in this._props) {
                window._Mfb_ud[property] = this[property];
            }

            var mfb = document.createElement("script");
            mfb.type = "text/javascript";
            mfb.charset = "UTF-8";
            mfb.async = true;
            mfb.id = "MFBActor";
            mfb.src = 'https://actorssl-5637.kxcdn.com/actor/e5a6754486f45f9ac65f55ff3f149e30-1075/action';
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(mfb, s);
        }
    }
</script>

